module.exports = __webpack_public_path__ + "static/media/verify.db068fc1.png";